import { LabCanvas3D } from './LabCanvas3D';
import { type SolutionsSceneState, createSolutionsScene } from './solutionsScene';

export type { SolutionsSceneState } from './solutionsScene';

/**
 * Real-world view of the crystallisation model: a beaker of solution on a hot plate with a
 * thermometer, undissolved solid and the crystals that form on cooling. The 2D particle beakers
 * and the solubility graph beside it show the same state.
 */
export function SolutionsBeaker3D({ state, playing, label }: { state: SolutionsSceneState; playing: boolean; label: string }) {
  return <LabCanvas3D build={createSolutionsScene} state={state} playing={playing} label={label} hint="Drag to turn the beaker" />;
}
